/* oxlint-disable @fullscript/gql-file-usage */
import type { MutationHookOptions } from "@apollo/client";
import { useMutation, gql } from "@apollo/client";

import type { StoreFragment } from "@shared/data/fragments/StoreFragment/StoreFragment.fragment";
import { STORE_FRAGMENT } from "@shared/data/fragments/StoreFragment/StoreFragment.fragment";

const StoreCurrentSetupPage_Shared_Mutation = gql`
  mutation StoreCurrentSetupPage_Shared_Mutation($input: StoreCurrentSetupPageUpdateInput!) {
    storeCurrentSetupPageUpdate(input: $input) {
      store {
        ...StoreFragment
      }
      errors {
        message
      }
    }
  }
  ${STORE_FRAGMENT}
`;

interface StoreCurrentSetupPageData {
  storeCurrentSetupPageUpdate: {
    store: StoreFragment;
  };
}

interface Variables {
  input: {
    attributes?: {
      forProfit?: boolean;
      apiClientId?: string;
      skipToStep?: string;
    };
  };
}

const useStoreCurrentSetupPageMutation = (
  options?: MutationHookOptions<StoreCurrentSetupPageData, Variables>
) =>
  useMutation<StoreCurrentSetupPageData, Variables>(StoreCurrentSetupPage_Shared_Mutation, options);

export type { StoreCurrentSetupPageData };

/* oxlint-disable @fullscript/gql-no-manual-hook-declaration */
export { useStoreCurrentSetupPageMutation, StoreCurrentSetupPage_Shared_Mutation };
